module.exports = __webpack_public_path__ + "img/img0.19ba73b4.jpg";